import { render, staticRenderFns } from "./demandPromotion.vue?vue&type=template&id=36cf94a6&scoped=true"
import script from "./demandPromotion.vue?vue&type=script&lang=js"
export * from "./demandPromotion.vue?vue&type=script&lang=js"
import style0 from "./demandPromotion.vue?vue&type=style&index=0&id=36cf94a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cf94a6",
  null
  
)

export default component.exports